import { tokens as thumbnailStackTokens } from '@pkg/components/ThumbnailStack/tokens';

const CARD_INTERIOR_PADDING = 12;
const CARD_INTERIOR_PADDING_REDUCED = 8;

const LABEL_HEIGHT = 22;

export const tokens = {
    zindex: {
        base: 1,
        card: 2,
        ornament: 3,
        label: 4,
    },
    card: {
        wrapper: {
            radius: 6,
            spaceBefore: CARD_INTERIOR_PADDING_REDUCED,
        },
        children: {
            padding: CARD_INTERIOR_PADDING,
            minHeight: {
                default: 106,
                compact: 90,
            },
        },
    },
    deathGame: {
        zindex: {
            glow: 1,
            interior: 2,
        },
        interior: {
            gap: {
                default: 16,
                compact: 10,
            },
        },
        information: {
            offset: CARD_INTERIOR_PADDING_REDUCED,
        },
        label: {
            fontSize: {
                default: 12,
                compact: 10,
            },
        },
        clock: {
            gap: {
                default: 20,
                compact: 10,
            },
            divider: {
                width: 2,
                height: 10,
            },
            item: {
                gap: 6,
            },
        },
    },
    estValue: {
        label: {
            fontSize: 14,
        },
    },
    incoming: {
        section: {
            gap: 8,
            padding: {
                default: 20,
                compact: 16,
            },
        },
        keywordMarquee: {
            gap: 4,
            height: 12,
            fontSize: 16,
        },
    },
    label: {
        height: 22,
        fontSize: 12,
        paddingX: CARD_INTERIOR_PADDING,
    },
    meme: {
        zindex: {
            interior: 1,
        },
        thumbnail: {
            size: {
                default: 100,
                compact: 72,
            },
            spaceBefore: CARD_INTERIOR_PADDING_REDUCED,
            spaceAfter: CARD_INTERIOR_PADDING,
            radius: 10,
        },
        label: {
            fontSize: {
                default: 46,
                compact: 32,
            },
        },
    },
    ornament: {},
    priceGame: {
        zindex: {
            base: 1,
            glow: 2,
            currencyBg: 3,
            interior: 4,
        },
        currencyBg: {
            size: 180,
        },
        label: {
            offsetY: LABEL_HEIGHT / 2,
            offsetX: CARD_INTERIOR_PADDING,
        },
        ornament: {},
        interior: {
            gap: {
                default: 16,
                compact: 10,
            },
            paddingTop: CARD_INTERIOR_PADDING + LABEL_HEIGHT / 4,
        },
        column: {
            gap: CARD_INTERIOR_PADDING,
            offset: 4,
        },
        tierStats: {
            primary: {
                fontSize: {
                    default: 14,
                    compact: 12,
                },
            },
            secondary: {
                fontSize: {
                    default: 12,
                    compact: 10,
                },
            },
        },
        thumbnails: {
            offset: thumbnailStackTokens.item.offset,
        },
        maxTier: {
            width: thumbnailStackTokens.list.width - thumbnailStackTokens.item.offset,
            height: thumbnailStackTokens.list.height,
            fontSize: 48,
        },
    },
    resurrection: {
        zindex: {
            interior: 1,
        },
        label: {
            fontSize: {
                default: 56,
                compact: 36,
            },
        },
    },
};
